export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URL,
        postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUT_REDIRECT_URL,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
    },
};
export const loginRequest = {
    scopes: [
        "openid",
        "profile",
        "email",
        "offline_access",
        "api://63430915-ea32-40c9-9644-835cd749c3e3/access_as_user"
    ]
};